/* Custom events shopify forms */
function checkScroll() {
  const maxScrollHeight =
    document.documentElement.scrollHeight - document.documentElement.clientHeight;
  const scrollPosition = window.scrollY || window.pageYOffset;
  const scrollPercentage = (scrollPosition / maxScrollHeight) * 100;
  if (scrollPercentage >= 10 && document.querySelector("#app-embed-container-351735")) {
    document
      .querySelector("#app-embed-container-351735")
      .style.setProperty("display", "block", "important");
    document.querySelector("#app-embed-container-351735").classList.add("initialized");
    window.removeEventListener("scroll", checkScroll);
  }
}
window.addEventListener("scroll", checkScroll);
/* End Custom events shopify forms */

/* Custom styles shopify forms */
const interval = setInterval(() => {
  const shadowHost = document.querySelector("#app-embed-container-351735");
  if (shadowHost && shadowHost.shadowRoot) {
    const style = document.createElement("style");
    style.textContent = `
			#app-embed {
			  padding: 0 !important;
			}
			#label-phone_number, #label-email {
			  top: 18.5px !important;
			}
			._grid_stahb_148 {
				width: 100%;
        grid-template-rows: unset !important;
				max-width: 390px !important;
			}
      ._gridItem_stahb_172._imageLoaded_stahb_237 {
        background-size: contain !important;
      }
      ._formContainer_stahb_30 {
        border-radius: 4px !important;
      }
      ._formHeader_1nihh_19 h2 {
        width: 100px;
        height: 61px;
        margin: 5px auto !important;
        background-image: url(https://cdn.shopify.com/s/files/1/0661/2919/9281/files/happi-logo.png?v=1740068046);
        background-size: cover;
        background-repeat: no-repeat;
        display: block;
        background-position: center;
        -webkit-text-fill-color: transparent;
      }
      ._formHeader_1nihh_19 div p:first-child {
        height: 153px;
        margin: 5px auto !important;
        background-image: url(https://cdn.shopify.com/s/files/1/0661/2919/9281/files/take_20__off.png?v=1740068823);
        background-size: contain;
        background-repeat: no-repeat;
        display: block;
        background-position: center;
        -webkit-text-fill-color: transparent;
        padding: 10px 6px;
      }
      ._formContainerCloseButtonPosition_stahb_282 {
        top: 8px !important;
        right: 8px !important;
      }
      ._formCloseButton_1684x_4._withBackground_1684x_15 {
        background-color: #FFF !important;
      }
      ._gridItemContent_stahb_257 {
        padding: 20px !important;
      }
      ._formHeader_1nihh_19 div p { 
        font-size: 16px !important;
      }
      ._selectToggle_1yit2_25 {
          max-height: 51px !important;
      }
      .my-custom-class {
        background-color: yellow;
        padding: 10px;
      }
      ._container_3eyaa_70 {
        left: 20px;
      }
      ._teaserContainer_ou4pe_5 {
        box-sizing: border-box !important;
        border-radius: 4px 4px 0px 0px !important;
        background-color: rgb(255, 209, 0) !important;
        min-height: 50px !important;
        height: 100% !important;
        padding: 8px !important;
        display: flex !important;
        flex-direction: column !important;
        width: 280px !important;
        justify-content: center !important;
        box-shadow: unset !important;
      }
      ._teaserContainer_ou4pe_5 h3 {
        font-size: 22px !important;
        color: rgb(133, 133, 133) !important;
        font-weight: 600 !important;
        font-style: normal !important;
      }
      ._container_3eyaa_70._fadeAnimation_3eyaa_87 button ._formCloseButton_1684x_4 {
        display: none;
      }
      
    /* Success styles */
    ._formContainer_stahb_30[aria-label="Success"] {
      width: 100%;
      max-width: 780px !important;
    }
    ._formContainer_stahb_30._grid_stahb_148._tight_stahb_271._noImage_stahb_161[aria-label="Success"] ._gridItem_stahb_172._imageLoaded_stahb_237 {
      display: none;
    }
    ._formContainer_stahb_30._grid_stahb_148._tight_stahb_271._noImage_stahb_161[aria-label="Success"] ._gridItem_stahb_172._gridItemContent_stahb_257 {
      grid-area: unset !important;
      align-content: center;
    }
    ._formContainer_stahb_30._grid_stahb_148._tight_stahb_271._noImage_stahb_161[aria-label="Success"] ._gridItem_stahb_172._gridItemContent_stahb_257 h2 {
      width: 100px;
      height: 61px;
      margin: 5px auto -40px auto !important;
      background-image: url(https://cdn.shopify.com/s/files/1/0661/2919/9281/files/happi-logo.png?v=1740068046);
      background-size: cover;
      background-repeat: no-repeat;
      display: block;
      background-position: center;
      -webkit-text-fill-color: transparent;
    }
    ._formContainer_stahb_30._grid_stahb_148._tight_stahb_271._noImage_stahb_161[aria-label="Success"] ._gridItem_stahb_172._gridItemContent_stahb_257 div p {
      width: auto;
      max-width: 460px;
      height: 280px;
      margin: 16px auto !important;
      background-image: url(https://cdn.shopify.com/s/files/1/0661/2919/9281/files/thank-you-subscribe.png?v=1740074090);
      background-size: contain;
      background-repeat: no-repeat;
      display: block;
      background-position: center;
      align-content: end;
      font-size: 22px !important;
    }
    ._formContainer_stahb_30[aria-label="Success"] ._formContainerCloseButtonPosition_stahb_282 {
      width: 28px;
      height: 28px;
      background: white;
      border-radius: 999px;
      align-content: center;
      place-items: center;
    }
    ._formContainer_stahb_30[aria-label="Success"] ._formCloseButton_1684x_4 {
      display: flex;
    }
    /* End Successs styles */
      @media (min-width: 768px) {
        ._formContainer_stahb_30[aria-label="Success"] {
          display: grid !important;
        }
        ._grid_stahb_148 {
          width: 100%;
          grid-template-columns: repeat(2, 390px) !important;
          max-width: 780px !important;
			  }
        ._formContainer_stahb_30[aria-label="Success"] {
          grid-template-columns: repeat(2, 390px) !important;
          min-height: 540px;
        }
        ._formContainer_stahb_30._grid_stahb_148._tight_stahb_271._noImage_stahb_161[aria-label="Success"] ._gridItem_stahb_172._imageLoaded_stahb_237 {
          grid-area: unset !important;
          order: 2;
          background-image: url(https://cdn.shopify.com/s/files/1/0661/2919/9281/files/e0b02c94-a53e-48dd-84d6-e25ea5a55ba8_1.jpg?v=1740003400?width=640&height=860&crop=center);
          background-size: cover;
          background-repeat: no-repeat;
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    `;
    shadowHost.shadowRoot.appendChild(style);
    setTimeout(() => {
      checkScroll();
    }, 200);
    clearInterval(interval);
  }
}, 200);
/* End Custom styles shopify forms */
